/* cSpell:disable */

import { withEmbedInPath } from '@/lib/react-native/services/react-native.web-view'
import { ensureLeadingSlash } from '@/lib/utils/link-utils'

const BRAND = process.env.NEXT_PUBLIC_BRAND
export const SEARCH_TERM_QUERY_PARAM = 'term'

export const toCMSPage = (urlKey: string): string => {
  return ensureLeadingSlash(urlKey)
}

export const toEmbedSearchTargetUrl = (
  targetUrl: string,
  separator: string,
  searchEntry: string,
): string => {
  return withEmbedInPath(
    `${targetUrl}${separator}${SEARCH_TERM_QUERY_PARAM}=${encodeURIComponent(searchEntry)}`,
  )
}

export const toSearchTargetUrl = (
  targetUrl: string,
  separator: string,
  sanitizedSearchEntry: string,
): string => {
  return `${targetUrl}${separator}${SEARCH_TERM_QUERY_PARAM}=${encodeURIComponent(sanitizedSearchEntry)}`
}

export const toOurServicesPage = (anchor?: string): string => {
  return '/services-pour-professionnels' + (anchor ? '#' + anchor : '')
}

export const toLogisticsServices = (anchor?: string): string => {
  anchor = anchor?.replaceAll(/^#/g, '')

  switch (BRAND) {
    case 'prolians':
    case 'hydralians':
      return '/services-logistiques' + (anchor ? '#' + anchor : '')
    case 'dexis':
      return '/services-logistiques-industries' + (anchor ? '#' + anchor : '')
    default:
      return '#'
  }
}

export const toFinancingServices = (anchor?: string): string => {
  anchor = anchor?.replaceAll(/^#/g, '')

  return '/services-financements' + (anchor ? '#' + anchor : '')
}

export const toTechnicalServices = (anchor?: string): string => {
  anchor = anchor?.replaceAll(/^#/g, '')

  switch (BRAND) {
    case 'prolians':
    case 'hydralians':
      return '/services-techniques' + (anchor ? '#' + anchor : '')
    case 'dexis':
      return '/services-techniques-industries' + (anchor ? '#' + anchor : '')
    default:
      return '#'
  }
}

export const toSecurityServices = (anchor?: string): string => {
  anchor = anchor?.replaceAll(/^#/g, '')

  switch (BRAND) {
    case 'prolians':
    case 'hydralians':
      return '/services-securite' + (anchor ? '#' + anchor : '')
    case 'dexis':
      return '/services-securite-industries' + (anchor ? '#' + anchor : '')
    default:
      return '#'
  }
}

export const toFidelityProgramPage = (): string => {
  switch (BRAND) {
    case 'prolians':
      return '/prolians-et-moi'
    case 'hydralians':
      return '/hydralians-et-moi'
    default:
      return '#'
  }
}

export const toRseHubPage = (): string => {
  switch (BRAND) {
    case 'prolians':
      return '/rse-prolians-engage-avenir-durable'
    case 'hydralians':
      return '/rse-hydralians-engage-avenir-durable '
    case 'dexis':
      return '/rse-dexis-engage-avenir-durable '
    default:
      return '#'
  }
}

export const toOurCataloguesPage = '/catalogues'

export const toOurGuidesPage = '/conseils-et-aide-au-choix'

// As it is impossible to get the file tree from here, and the CMS pages don't have a prefix in the URL,
// we need to hardcode the list of CMS pages that should be redirected to the headless CMS format.
// If a new page is added to the CMS, it should be added to this list as well.
export const cmsPageRoutes: string[] = [
  '/votre-magasin-lego',
  '/univers-amenagement-atelier',
  '/solutions-reseaux-pour-tp-eau-assainissement-voirie',
  '/service-colisbox',
  '/protection-mains-gants-securite',
  '/prolians-et-moi',
  '/prolians-days',
  '/politique-de-confidentialite',
  '/partenariat-dexis-rockwell-automation',
  '/operation-saint-valentin',
  '/nos-marques',
  '/mypack-prolians',
  '/mentions-legales',
  '/livraison-j1',
  '/livraison',
  '/index-egalite-femmes-hommes-vama-docks',
  '/index-egalite-femmes-hommes-smg',
  '/index-egalite-femmes-hommes-servet-duchemin',
  '/index-egalite-femmes-hommes-schmerber',
  '/index-egalite-femmes-hommes-rhone-alpes-auvergne',
  '/index-egalite-femmes-hommes-provence-cote-azur',
  '/index-egalite-femmes-hommes-prevot-smeta',
  '/index-egalite-femmes-hommes-nouvelle-aquitaine',
  '/index-egalite-femmes-hommes-normandie',
  '/index-egalite-femmes-hommes-midi-pyrenees-scellement',
  '/index-egalite-femmes-hommes-martin-heulin',
  '/index-egalite-femmes-hommes-ile-de-france',
  '/index-egalite-femmes-hommes-hydralians-somair-gervat',
  '/index-egalite-femmes-hommes-hydralians-prosjet-irrigarone',
  '/index-egalite-femmes-hommes-hydralians-dc-plastiques',
  '/index-egalite-femmes-hommes-guermont-weber',
  '/index-egalite-femmes-hommes-dexis-tampleu-spriet',
  '/index-egalite-femmes-hommes-dexis-safim',
  '/index-egalite-femmes-hommes-dexis-hudry',
  '/index-egalite-femmes-hommes-dexis-guilman',
  '/index-egalite-femmes-hommes-dexis-distrilab',
  '/index-egalite-femmes-hommes-dexis-cetib',
  '/index-egalite-femmes-hommes-dexis-boutillon',
  '/index-egalite-femmes-hommes-dexis-bfl',
  '/index-egalite-femmes-hommes-dexis-bfc-automatismes',
  '/index-egalite-femmes-hommes-cmb',
  '/index-egalite-femmes-hommes-caso',
  '/index-egalite-femmes-hommes-burdin-maringue',
  '/index-egalite-femmes-hommes-bossu-cuvelier',
  '/index-egalite-femmes-hommes-bernard-pages',
  '/index-egalite-femmes-hommes-beauplet-languille',
  '/index-egalite-femmes-hommes-baures',
  '/hydratest-analyse-eau-piscine-spa',
  '/hydralians-et-moi',
  '/genie-climatique-sanitaire-plomberie',
  '/flowdians-connect',
  '/fete-des-meres-cartecadeau-interflora',
  '/fete-des-meres-carte-cadeau-interflora',
  '/economies-eau-energie',
  '/conseils-et-aide-au-choix',
  '/conditions-generales-de-vente',
  '/conditions-generales-d-utilisation',
  '/comment-choisir-son-hivernage-piscine',
  '/comment-choisir-protection-respiratoire',
  '/comment-choisir-protection-jetable-professionnelle',
  '/comment-choisir-protection-auditive',
  '/comment-choisir-lunettes-protection-yeux',
  '/comment-choisir-eclairage',
  '/comment-choisir-casquette-de-securite',
  '/comment-choisir-casque-protection',
  '/comment-bien-choisir-systemes-virtuels-soudure',
  '/comment-bien-choisir-normes-securite-salle-bains',
  '/comment-bien-choisir-normes-gtl-gaine-technique-logement',
  '/comment-bien-choisir-norme-atex',
  '/comment-bien-choisir-lames-scies-ruban',
  '/comment-bien-choisir-gants-resistance-chimique',
  '/comment-bien-choisir-equipement-electrique-minimal-piece-par-piece',
  '/comment-bien-choisir-emplacement-tableau-electrique',
  '/comment-bien-choisir-couleurs-fils-installation-electrique',
  '/comment-bien-choisir-circuits-electriques-logement',
  '/comment-bien-choisir-centres-services-cylindres',
  '/choisir-vetement-travail',
  '/choisir-un-organigramme-de-cles',
  '/choisir-son-telemetre-laser',
  '/choisir-son-scellement-chimique',
  '/choisir-son-ruban-adhesif',
  '/choisir-son-disque-diamant',
  '/choisir-son-compresseur-piston',
  '/choisir-ses-raccords-et-embouts',
  '/choisir-serrure',
  '/choisir-sa-bande-abrasive',
  '/choisir-equipement-antichute',
  '/choisir-chaussures-securite',
  '/choisir-bequille-porte',
  '/catalogues',
  '/catalogue-pro-et-dispo',
  '/bien-choisir-son-ferme-porte',
  '/bien-choisir-son-cylindre-de-serrure',
  '/bien-choisir-sa-barre-anti-panique',
  '/amenagements-exterieurs-clotures',
  '/aciers-construction',
  '/acier',
  '/accessibilite-salles-bains',
  '/services-techniques-industries',
  '/services-techniques',
  '/services-securite-industries',
  '/services-securite',
  '/services-pour-professionnels',
  '/services-logistiques-industries',
  '/services-logistiques',
  '/services-financements',
  '/soudure-virtuelle-competences-industrielles',
  '/simulation-apprentissage-soudure',
  '/selection-responsable-produits-plus-transparents-rse',
  '/securiser-approvisionnements-internationaux-metiers-eau-paysage',
  '/securiser-achats-metiers-eau-paysage',
  '/securiser-achat-chantiers',
  '/securisation-approvisionnements-industriels',
  '/securisation-achats-industriels',
  '/seconde-vie-outils-performance-responsable-myr-eco-mypack',
  '/reduction-fuites-air-comprime-performance-industrielle',
  '/protection-equipes-industrie',
  '/produits-rse-performance-industrielle-durable',
  '/optimisation-roulements-consommation-energie',
  '/opsial-xhander-metiers-eau',
  '/opsial-xhander-marques-engagees-service-professionnels',
  '/opsial-xhander-equipements-responsables-performance-industrielle',
  '/exosquelettes-soulagement-sans-transformer-metier',
  '/exosquelettes-reduire-fatigue-securiser-gestes',
  '/equipement-metiers-eau-paysage',
  '/epi-categorie-3-securite-conformite-tracabilite',
  '/epi-categorie-3-securite-conformite-durabilite',
  '/epi-categorie-3-maintenance',
  '/decarboner-metiers-eau',
  '/decarboner-industrie',
  '/decarboner-filiere-batiment',
  '/competitivite-responsabilite-achats',
  '/chaine-valeur-responsable',
  '/chaine-valeur-maitrisee',
  '/bon-choix-equipement-chantiers',
  '/acier-bas-carbone',
  '/rse-prolians-engage-avenir-durable',
  '/rse-hydralians-engage-avenir-durable',
  '/rse-dexis-engage-avenir-durable',
  '/service-click-collect',
  '/service-click-and-collect-2h',
  '/xhander-outillage-fournitures-equipements-industrie',
  '/xhander-notre-marque',
  '/opsial-notre-marque',
  '/opsial-epi-industrie',
  '/4mp-usinage-transmission-puissance',
  '/partenaires-des-metiers-de-la-construction',
  '/partenaire-industries',
  '/partenaire-des-metiers-de-l-eau-et-du-paysage',
]
